import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import API from 'app/modules/common/services/api.config.json';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class GruposEmpresaService {

    public recargarGrupos$: Subject<void> = new Subject<void>();

    constructor(private apiService: ApiService) { }

    getGrupos(): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.getGrupos}`;
        return this.apiService.get(url);
    }

    getGrupoById(grupoId: number): Observable<RestResponse> {
        let url = `${API.CarteraEmpresas.getGrupoById}`;
        url = url.replace('{grupoId}', grupoId.toString());
        return this.apiService.get(url);
    }

    crearGrupo(data: { nombre: string; empresaIds: number[] }): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.crearGrupo}`;
        return this.apiService.post(url, data);
    }

    editarGrupo(data: { grupoId: number; nombre: string }): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.editarGrupo}`;
        return this.apiService.post(url, data);
    }

    eliminarGrupo(grupoId: number): Observable<RestResponse> {
        let url = `${API.CarteraEmpresas.eliminarGrupo}`;
        url = url.replace('{grupoId}', grupoId.toString());
        return this.apiService.delete(url);
    }

    anadirEmpresa(data: { grupoId: number; empresaId: number }): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.anadirEmpresa}`;
        return this.apiService.post(url, data);
    }

    quitarEmpresa(data: { grupoId: number; empresaId: number }): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.quitarEmpresa}`;
        return this.apiService.post(url, data);
    }

    rellenarLista(): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.rellenarLista}`;
        return this.apiService.post(url, {});
    }

    getEmpresas(): Observable<RestResponse> {
        const url = `${API.CarteraEmpresas.getEmpresas}`;
        return this.apiService.get(url);
    }
} 